module.exports = __webpack_public_path__ + "media/base/file-7029ca8e.svg";